import React from "react"
import { StyledLoader } from "./LoaderStyle"

const Loader = () => {
    return (
        <React.Fragment>
            <div className="d-flex justify-content-center p-2">
                <StyledLoader className="spinner-border text-primary"></StyledLoader>
            </div>
        </React.Fragment>
    )
}
export default Loader